export default __webpack_public_path__ + "static/media/bed1.55cf51c4.jpg";